import { makeAutoObservable } from 'mobx'

export interface TabItem {
  key: string
  label: string
  path: string
  closable?: boolean
}

class TabStore {
  tabs: TabItem[] = [
    {
      key: '/firmware/list',
      label: '小包列表',
      path: '/firmware/list',
      closable: false, // 固件列表不可关闭
    },
  ]
  activeKey: string = '/firmware/list'

  constructor() {
    makeAutoObservable(this)
  }

  // 添加标签页
  addTab = (tab: TabItem) => {
    const existingTab = this.tabs.find(t => t.key === tab.key)
    if (!existingTab) {
      this.tabs.push({
        ...tab,
        closable: tab.closable !== false, // 默认可关闭
      })
    }
    this.activeKey = tab.key
  }

  // 移除标签页
  removeTab = (targetKey: string) => {
    if (this.tabs.length === 1) return

    const targetIndex = this.tabs.findIndex(tab => tab.key === targetKey)
    if (targetIndex === -1) return

    // 如果关闭的是当前激活的标签，需要切换到其他标签
    if (this.activeKey === targetKey) {
      const newActiveIndex = targetIndex === 0 ? 1 : targetIndex - 1
      this.activeKey = this.tabs[newActiveIndex].key
    }

    this.tabs = this.tabs.filter(tab => tab.key !== targetKey)
  }

  // 设置当前激活的标签
  setActiveKey = (key: string) => {
    this.activeKey = key
  }

  // 关闭其他标签页
  closeOthers = (currentKey: string) => {
    this.tabs = this.tabs.filter(tab => tab.key === currentKey || !tab.closable)
    this.activeKey = currentKey
  }

  // 关闭所有标签页（除了不可关闭的）
  closeAll = () => {
    const unclosableTabs = this.tabs.filter(tab => !tab.closable)
    this.tabs = unclosableTabs
    if (unclosableTabs.length > 0) {
      this.activeKey = unclosableTabs[0].key
    }
  }
}

export const tabStore = new TabStore()
export const useTabStore = () => tabStore
